import { useContext, useEffect, useState } from "react";
import SeleccionContext from "../../../../../context/Seleccion/SeleccionContext";
import SeccionDetalleProceso from "./SeccionDetalleProceso";

interface IModalDetalleProceso {
  title: string;
  onChangeBack?: Function;
  buttonBack?: string;
  list?: any[];
  token: string | undefined;
  getToken: Function;
}

export default (props: IModalDetalleProceso) => {
  const { title, onChangeBack, buttonBack, list, token } = props;
  const { getProcesos, listProcesos } = useContext(SeleccionContext);

  // Arranca en "cargando" cuando vamos a pedir los datos, para no renderizar el
  // modal antes de tenerlos. getProcesos hace setIsLoading(true) dentro de un
  // effect (tras el primer render); si isLoading arrancara en false, el modal se
  // mostraba, se ocultaba al entrar en carga y volvía a mostrarse con los datos,
  // produciendo el parpadeo (abrir/cerrar/abrir).
  const [isLoading, setIsLoading] = useState<boolean>(Boolean(token && list));

  useEffect(() => {
    if (token && list) {
      getProcesos({ token, procesos: list, setIsLoading });
    }
  }, [token]);

  const handleClickCloseModal = () => {
    typeof onChangeBack == "function" && onChangeBack();
  };

  return (
    <>
      {!isLoading && (
        <>
          <div className="modal-container-seleccion">
            <div
              className="modal-content-seleccion w-80"
            >
              <div className="modal-title">
                <span>{title}</span>
              </div>

              {list && (
                <>
                  {listProcesos &&
                    listProcesos.map((item: any) => {
                      return (
                        <SeccionDetalleProceso
                          list={item}
                          listaMasiva={false}
                          soloDetalle={true}
                        />
                      );
                    })}
                </>
              )}

              <div className="modal-button-content center">
                <>
                  <button
                    className={`modal-button cancel`}
                    onClick={handleClickCloseModal}
                  >
                    {buttonBack ? buttonBack : "Cerrar"}
                  </button>
                </>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
